/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ScheduledChangeSwapRequestReasonCode } from './scheduledChangeSwapRequestReasonCode';
import type { ScheduledChangeSwapRequestNote } from './scheduledChangeSwapRequestNote';

export interface ScheduledChangeSwapRequest {
  questionId: string;
  replacementId: string;
  reasonCode: ScheduledChangeSwapRequestReasonCode;
  note?: ScheduledChangeSwapRequestNote;
  etag: string;
  toggleResourceIds?: string[];
}
